"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 0, 6, 0),
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(0, 0, 10, 0)
        }
    };
});
